import { AuthLayout } from "@/components/catalyst/AuthLayout";
import { Heading } from "@/components/catalyst/Heading";
import { Logo } from "@/components/Logo";
import { TurnstileProvider } from "@/hooks/use-turnstile";
import { Form } from "./Form";

export function SignUp() {
	return (
		<AuthLayout>
			<TurnstileProvider>
				<div className="flex flex-col gap-6 w-full max-w-md">
					<div className="flex flex-col items-center gap-4">
						<Logo />
						<Heading>Sign up for your account</Heading>
					</div>
					<Form />
				</div>
			</TurnstileProvider>
		</AuthLayout>
	);
}
